import { render, staticRenderFns } from "./OrderInvite.vue?vue&type=template&id=089c15f8"
import script from "./OrderInvite.vue?vue&type=script&lang=js"
export * from "./OrderInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports